/* ROOF_ENGINE — GreenSteel / base toiture EDILIANS 2026
 * Moteur autonome, hors thème Shopify. Unités : mètres, degrés, € HT.
 * Aucun prix ni coefficient de consommation dans ce fichier : tout vient de ROOF_DATABASE_2026.
 * Donnée manquante => statut NEED_VALIDATION (jamais d'estimation).
 */
(function (root) {
'use strict';
const OK = 'OK', NEED = 'NEED_VALIDATION', NON_CONFORME = 'NON_CONFORME';

/* ---------- géométrie : polygone réel, faces et arêtes en 3D ---------- */
const P3 = (x, y, z) => ({ x, y, z: z || 0 });
const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y, a.z - b.z);
function area3(pts) { // aire d'un polygone plan dans l'espace (Newell)
  let nx = 0, ny = 0, nz = 0;
  for (let i = 0; i < pts.length; i++) {
    const a = pts[i], b = pts[(i + 1) % pts.length];
    nx += (a.y - b.y) * (a.z + b.z); ny += (a.z - b.z) * (a.x + b.x); nz += (a.x - b.x) * (a.y + b.y);
  }
  return Math.hypot(nx, ny, nz) / 2;
}
const planArea = pts => area3(pts.map(p => P3(p.x, p.y, 0)));

/* Contour d'égout = emprise réelle décalée du débord (angles droits). */
function eaveOutline(shape, ov) {
  if (shape.type === 'rect') return { type: 'rect', W: shape.W + 2 * ov, D: shape.D + 2 * ov };
  if (shape.type === 'L') {
    // L = rectangle W x D dont on retire une encoche a x b dans un angle.
    const sA = shape.D - shape.b, sB = shape.W - shape.a; // profondeur aile A, largeur aile B
    if (!(shape.a > 0 && shape.b > 0 && sA > 0 && sB > 0)) throw new Error('L invalide');
    return { type: 'L', W: shape.W + 2 * ov, D: shape.D + 2 * ov, sA: sA + 2 * ov, sB: sB + 2 * ov };
  }
  throw new Error('forme non gérée : ' + shape.type);
}

/* Un pan sur un polygone quelconque (sommets dans le sens trigonométrique) : pente montante dans la direction dir.
   Arête horizontale avec le pan du côté amont = égout ; côté aval = rive haute ; arête dans le sens de la pente = rive. */
function monoPan(v2, dir, t, S, faces) {
  const g = { 'x+': [1, 0], 'x-': [-1, 0], 'y+': [0, 1], 'y-': [0, -1] }[dir]; if (!g) throw new Error('sens de pente inconnu : ' + dir);
  const pr = v2.map(([x, y]) => x * g[0] + y * g[1]), m = Math.min(...pr);
  const v = v2.map(([x, y], i) => P3(x, y, t * (pr[i] - m))); faces.push(v);
  v.forEach((a, i) => { const b = v[(i + 1) % v.length], nx = -(b.y - a.y), ny = b.x - a.x, d = nx * g[0] + ny * g[1];
    S(Math.abs(d) < 1e-9 ? 'rive' : d > 0 ? 'egout' : 'rive_haute', a, b); });
}

function build(shape, roofType, pitchDeg, ov, opt) {
  opt = typeof opt === 'string' ? { monoDir: opt + '+' } : (opt || {});
  const monoDir = opt.monoDir || 'y+';
  const t = Math.tan(pitchDeg * Math.PI / 180);
  let e = eaveOutline(shape, ov), swapped = false;
  const faces = [], seg = [];
  const S = (type, a, b) => seg.push({ type, a, b, len: dist(a, b) });
  const warn = [];

  if (e.type === 'rect') {
    const wantSwap = roofType === 'bi' && opt.ridgeAxis ? opt.ridgeAxis === 'y' : e.D > e.W; // 2 pans : sens du faîtage choisi ; sinon faîtage dans la longueur
    if (roofType !== 'mono' && wantSwap) { e = { type: 'rect', W: e.D, D: e.W }; swapped = true; }
    const W = e.W, s = e.D, h = t * s / 2;
    const p0 = P3(0, 0), p1 = P3(W, 0), p2 = P3(W, s), p3 = P3(0, s);
    if (roofType === 'mono') {
      monoPan([[0, 0], [W, 0], [W, s], [0, s]], monoDir, t, S, faces);
    } else if (roofType === 'bi') {
      const g0 = P3(0, s / 2, h), g1 = P3(W, s / 2, h);
      faces.push([p0, p1, g1, g0], [p2, p3, g0, g1]);
      S('faitage', g0, g1); S('egout', p0, p1); S('egout', p2, p3);
      S('rive', p0, g0); S('rive', g0, p3); S('rive', p1, g1); S('rive', g1, p2);
    } else if (roofType === 'hip') {
      const a1 = P3(s / 2, s / 2, h), a2 = P3(W - s / 2, s / 2, h);
      faces.push([p0, p1, a2, a1], [p1, p2, a2], [p2, p3, a1, a2], [p3, p0, a1]);
      if (W - s > 1e-9) S('faitage', a1, a2);
      S('aretier', p0, a1); S('aretier', p3, a1); S('aretier', p1, a2); S('aretier', p2, a2);
      S('egout', p0, p1); S('egout', p1, p2); S('egout', p2, p3); S('egout', p3, p0);
    } else throw new Error('type de toiture non géré : ' + roofType);
  } else { // L
    if (roofType !== 'mono' && e.sB > e.sA) { e = { type: 'L', W: e.D, D: e.W, sA: e.sB, sB: e.sA }; swapped = true; } // aile A = la plus profonde
    const W = e.W, D = e.D, sA = e.sA, sB = e.sB;
    if (roofType === 'mono') {
      monoPan([[0, 0], [W, 0], [W, sA], [sB, sA], [sB, D], [0, D]], monoDir, t, S, faces);
    } else {
      if (W < sA - 1e-9) return { status: NEED, reason: 'aile principale plus profonde que longue : géométrie non couverte' };
      const hA = t * sA / 2, hB = t * sB / 2;
      const p0 = P3(0, 0), p1 = P3(W, 0), p2 = P3(W, sA), r = P3(sB, sA), p4 = P3(sB, D), p5 = P3(0, D);
      const a1 = P3(sA / 2, sA / 2, hA), b1 = P3(sB / 2, sA - sB / 2, hB), same = sA - sB < 1e-9;
      S('noue', r, b1); S('aretier', p0, a1); if (!same) S('aretier', b1, a1); // arêtier d'angle + arêtier de raccord
      S('egout', p0, p1); S('egout', p2, r); S('egout', r, p4); S('egout', p5, p0);
      if (roofType === 'hip') {
        const a2 = P3(W - sA / 2, sA / 2, hA), b2 = P3(sB / 2, D - sB / 2, hB);
        faces.push([p0, p1, a2, a1], [p1, p2, a2], [p2, r, b1, a1, a2], [r, p4, b2, b1], [p4, p5, b2], [p5, p0, a1, b1, b2]);
        if (W - sA > 1e-9) S('faitage', a1, a2); if (D - sA > 1e-9) S('faitage', b1, b2);
        S('aretier', p1, a2); S('aretier', p2, a2); S('aretier', p4, b2); S('aretier', p5, b2);
        S('egout', p1, p2); S('egout', p4, p5);
      } else if (roofType === 'bi') {
        const g1 = P3(W, sA / 2, hA), g2 = P3(sB / 2, D, hB);
        faces.push([p0, p1, g1, a1], [p2, r, b1, a1, g1], [r, p4, g2, b1], [p5, p0, a1, b1, g2]);
        S('faitage', a1, g1); S('faitage', b1, g2);
        S('rive', p1, g1); S('rive', g1, p2); S('rive', p4, g2); S('rive', g2, p5);
        warn.push('L 2 pans : convention retenue = pignons en bout d\'ailes, arêtier à l\'angle sortant, noue à l\'angle rentrant (validée le 08/10/2026).');
      } else throw new Error('type de toiture non géré : ' + roofType);
    }
  }
  const sum = k => seg.filter(s => s.type === k).reduce((n, s) => n + s.len, 0);
  const emprise = shape.type === 'rect' ? shape.W * shape.D : shape.W * shape.D - shape.a * shape.b;
  const egoutPlan = e.type === 'rect' ? e.W * e.D : e.W * e.sA + e.sB * (e.D - e.sA);
  return {
    status: OK, swapped, warn, faces, segments: seg, emprise, surfaceEgoutPlan: egoutPlan,
    surfaceFacesPlan: faces.reduce((n, f) => n + planArea(f), 0),
    rampant: faces.reduce((n, f) => n + area3(f), 0),
    faitage: sum('faitage'), rives: sum('rive'), riveHaute: sum('rive_haute'), aretiers: sum('aretier'), noues: sum('noue'), egout: sum('egout'),
    nb: { pans: faces.length, aretiers: seg.filter(s => s.type === 'aretier').length, noues: seg.filter(s => s.type === 'noue').length, pignons: seg.filter(s => s.type === 'rive').length / 2 }
  };
}

/* ---------- pente minimale DTU (tableaux des fiches EDILIANS, en %) ---------- */
function checkPente(db, o, G) {
  const pm = (db.pentes_min || []).find(p => p.tile === o.tile);
  if (!(o.pitch > 0)) return { status: NEED, pct: 0, message: 'Pente nulle : toiture tuile impossible' };
  const zone = o.zone == null ? null : Number(o.zone);
  const pct = Math.tan(o.pitch * Math.PI / 180) * 100, t = Math.tan(o.pitch * Math.PI / 180);
  if (!pm) return { status: NEED, pct, message: 'Pente minimale : tableau EDILIANS non fourni pour ' + o.tile + ' — Prescription fournisseur à vérifier' };
  const run = Math.max(...G.faces.flat().map(p => p.z)) / t; // projection horizontale du plus long rampant
  const col = v => Array.isArray(v) ? (run <= 6.5 ? v[0] : run <= 9.5 ? v[1] : run <= 12 ? v[2] : null) : v;
  const table = o.ecran ? pm.avec_ecran : pm.sans_ecran, cells = [];
  table.forEach(r => [1, 2, 3].forEach(z => cells.push({ site: r.site, zone: z, min: col(r['zone' + z]) })));
  if (cells.some(c => c.min == null)) return { status: NEED, pct, run, message: 'Pente minimale ' + o.tile + ' : rampant de plus de 12 m en projection — hotline EDILIANS' };
  const cell = cells.find(c => c.site === o.site && c.zone === zone), lo = Math.min(...cells.map(c => c.min));
  if (cell) return pct + 1e-9 >= cell.min ? { status: OK, pct, run, min: cell.min }
    : { status: NON_CONFORME, pct, run, min: cell.min, message: 'Configuration non conforme : pente ' + pct.toFixed(1) + ' % inférieure au minimum DTU ' + o.tile + ' (' + cell.min + ' %, ' + o.site + ', zone ' + o.zone + (o.ecran ? ', avec écran' : ', sans écran') + ')' };
  if (pct + 1e-9 < lo) return { status: NON_CONFORME, pct, run, min: lo, message: 'Configuration non conforme : pente ' + pct.toFixed(1) + ' % inférieure à tous les minimums DTU ' + o.tile + (o.ecran ? ' avec écran' : ' sans écran') + ' (le plus bas : ' + lo + ' %)' };
  const ko = cells.filter(c => pct + 1e-9 < c.min).map(c => c.site + ' z' + c.zone);
  return { status: NEED, pct, run, message: 'Pente minimale ' + o.tile + ' : zone et site du projet à renseigner' + (ko.length ? ' (pente ' + pct.toFixed(1) + ' % insuffisante en : ' + ko.join(', ') + ')' : '') };
}

/* ---------- quantitatif : uniquement des règles et tarifs de la base ---------- */
function quote(db, input) {
  const o = Object.assign({ pitch: 25, overhang: 0.30, rive: 'universelle', ecran: false, color: 'flamme_rustique' }, input);
  const G = build(o.shape, o.roof, o.pitch, o.overhang, { monoDir: o.monoDir || (o.monoAxis ? o.monoAxis + '+' : 'y+'), ridgeAxis: o.ridgeAxis });
  if (G.status !== OK) return { status: NEED, geometry: G, lines: [], needs: [G.reason] };
  const lines = [], needs = [];
  const tile = db.tiles[o.tile];
  const find = (family, color) => db.accessories.filter(a => a.family === family && a.tile_compatibility.includes(o.tile) && (color === undefined || a.color === color || a.color === null));
  const push = (family, label, qty, unit, a, why) => {
    const pu = a && a.price_status === 'REFERENCE_ONLY' ? a.price_catalogue_ht : null, miss = why || (pu == null ? (a && a.price_status === 'CONFLICT' ? 'prix catalogue en conflit' : 'prix à confirmer') : null);
    // pu / total = prix catalogue de référence ; coutAchat = uniquement cost_purchase_ht de la base.
    const achat = a && a.cost_purchase_ht != null ? a.cost_purchase_ht : null;
    const l = { family, label, reference: a ? a.reference : null, qty, unit, pu, prixStatut: pu == null ? null : 'REFERENCE_ONLY', total: (!miss && qty != null) ? qty * pu : null, coutAchat: (!miss && qty != null && achat != null) ? qty * achat : null, status: miss ? NEED : OK, note: miss || '' };
    lines.push(l); if (miss) needs.push(label + ' : ' + miss); return l;
  };
  const pieces = (family, label, len, a) => {
    if (len <= 1e-9) return;
    if (!a) return push(family, label, null, 'pièce', null, 'référence absente pour ce coloris');
    if (a.consumption == null) return push(family, label, null, 'pièce', a, 'règle de quantité à confirmer');
    return push(family, label, Math.ceil(len * a.consumption - 1e-9), 'pièce', a);
  };
  if (!tile) return { status: NEED, geometry: G, lines, needs: ['tuile inconnue : ' + o.tile] };

  // Tuiles : consommation verrouillée uniquement si la base la donne ; quantité nette, sans perte ajoutée.
  const tc = db.tile_colors.find(c => c.tile === o.tile && c.color === o.color);
  if (tile.consommation_catalogue_m2 == null) push('tuile', 'Tuiles ' + o.tile, null, 'pièce', tc ? Object.assign({ reference: tile.reference }, tc) : null, 'consommation au m² non verrouillée pour ' + o.tile);
  else push('tuile', 'Tuiles ' + o.tile, Math.ceil(G.rampant * tile.consommation_catalogue_m2 - 1e-9), 'pièce', tc ? Object.assign({ reference: tile.reference }, tc) : null, tc ? null : 'prix à confirmer pour ce coloris');
  needs.push('Pertes : taux par famille non fourni (quantités nettes, aucune majoration appliquée)');

  // Liteaux : coefficient verrouillé par gamme (jamais recalculé depuis le pureau).
  push('liteau', 'Liteaux', G.rampant * tile.liteaux_ml_m2, 'ml', db.accessories.find(a => a.family === 'liteau')); // longueur nette : optimisation des barres et chutes non comptées

  // Rives : universelles ou spécifiques, jamais confondues.
  if (G.rives > 0) pieces(o.rive === 'specifique' ? 'rive_specifique' : 'rive_universelle', o.rive === 'specifique' ? 'Rives spécifiques' : 'Rives universelles 1050',
    G.rives, o.rive === 'specifique' ? find('rive_specifique')[0] : find('rive_universelle', o.color).find(a => a.color === o.color));
  if (G.riveHaute > 0) push('rive_haute', 'Rive haute de monopente', G.riveHaute, 'ml', null, 'pièce de tête non référencée');

  // Faîtières et arêtiers : deux familles distinctes.
  pieces('faitiere', 'Faîtières 717', G.faitage, find('faitiere', o.color).find(a => a.color === o.color));
  pieces('aretier', 'Arêtiers 758', G.aretiers, find('aretier', o.color).find(a => a.color === o.color));
  if (G.faitage + G.aretiers > 0) {
    const clo = find('closoir').find(a => a.compatibility && a.compatibility.galbe && a.compatibility.galbe === tile.galbe);
    push('closoir', 'Closoir de faîtage et d\'arêtier', G.faitage + G.aretiers, 'ml', clo || null, clo ? null : 'galbe et référence à vérifier');
    push('about', 'Abouts de faîtière / d\'arêtier / de rive', null, 'pièce', null, 'dépend du système de faîtage / d\'arêtier retenu');
  }
  if (G.noues > 0) {
    push('noue', 'Noues', G.noues, 'ml', find('noue')[0], 'référence de noue à choisir (recouvrements et coupes non comptés)');
    push('contre_latte_noue', 'Contre-liteaux de noue', null, 'ml', find('contre_latte_noue')[0], 'règle géométrique et prix à renseigner');
  }
  if (G.faitage > 0) push('contre_latte_rehausse_faitage', 'Rehausse de faîtage', null, 'ml', find('contre_latte_rehausse_faitage')[0], 'règle et prix à renseigner');
  push('egout_ventile', 'Égout : liteau ventilé + peigne', G.egout, 'ml', find('egout_ventile')[0]);

  // Écran : jamais automatique.
  if (o.ecran === true) {
    push('ecran', 'Écran de sous-toiture', G.rampant, 'm2', find('ecran')[0]);
    push('contre_latte_ecran', 'Contre-lattes d\'écran', null, 'ml', find('contre_latte_ecran')[0], 'entraxe et prix à renseigner');
  }
  // Fixation, ventilation, pente : prescription fournisseur, aucune valeur forfaitaire.
  const fix = (db.fixation_prescriptions || []).find(f => f.tile === o.tile && f.zone === o.zone && f.site === o.site);
  if (!fix) push('fixation', 'Fixation des tuiles', null, 'pièce', null, 'Prescription fournisseur à vérifier');
  push('ventilation', 'Ventilation de la couverture', null, 'pièce', null, 'Prescription fournisseur à vérifier (le closoir ne compte pas comme ventilation)');
  const pente = checkPente(db, o, G);
  if (pente.status !== OK) needs.push(pente.message);
  else if (pente.warning) needs.push(pente.warning);

  if (lines.some(l => l.coutAchat == null)) needs.push('Coût d\'achat incomplet : lignes sans prix d\'achat (voir détail)');
  const known = lines.filter(l => l.status === OK), prixClient = G.rampant * db.pricing.prix_client_m2_rampant_ht;
  return {
    status: pente.status === NON_CONFORME ? NON_CONFORME : needs.length ? NEED : OK, conformite: pente.status, geometry: G, pente, lines, needs, warnings: G.warn,
    prixClientHT: prixClient, catalogueReferenceHT: known.reduce((n, l) => n + l.total, 0),
    coutAchatHT: lines.every(l => l.coutAchat != null) ? lines.reduce((n, l) => n + l.coutAchat, 0) : null, coutComplet: lines.every(l => l.status === OK && l.coutAchat != null)
  };
}

const API = { build, quote, checkPente, OK, NEED, NON_CONFORME, version: '2026-10-08' };
if (typeof module !== 'undefined' && module.exports) module.exports = API; else root.GSRoof = API;
})(typeof globalThis !== 'undefined' ? globalThis : this);
